import styles from './BorderRadiusInput.module.css'
import CustomNumber from '../../../../../../../components/CustomNumber/CustomNumber'

function BorderRadiusInput({ name, value, onChange }) {
  return (
    <div className={styles.container}>
      <CustomNumber
        name={name}
        value={value}
        onChange={onChange}
        min={0}
        step={1}
      />
    </div>
  )
}

export default BorderRadiusInput
